var map = {
	"./agordoj.svg": 24,
	"./busho.svg": 21,
	"./domo.svg": 22,
	"./konservilo.svg": 35,
	"./konversacio.svg": 63,
	"./leciono.svg": 23,
	"./lernantino.svg": 64,
	"./lupeo.svg": 25,
	"./reen.svg": 27,
	"./zamenhof.png": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;